// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"b7e02020","93":"ee09e3e6","154":"d13acb50","194":"b7c8f063","254":"7899601c","394":"3c9de1b4","787":"837b3497","807":"231b89ba"}[chunkId] + ".chunk.js";
};